var XPortal = XPortal || {};
XPortal.Format = (function () {
    var self = { alertTemplate: null, valueSeparator: "_#_" };
    self.Link = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        var opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        let html = "";
        if (opts.settings && opts.settings.url) {
            html = getLinkHtml(opts, {});
            return self.WrapCellExtended(html, item, nodeId, dfield);
        }
        html = processTemplate("[[" + dfield + "]]", null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };
    self.Alert = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        var opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        let html = "";
        if (opts.settings) {
            const r = getAlertModel(opts);
            const tmplHtml = htmlTemplate || (self.alertTemplate || (self.alertTemplate = $("#gridAlertTemplate").html()));
            html = processTemplate(tmplHtml, null, r, nodeId, dfield);
            return self.WrapCellExtended(html || "", item, nodeId, dfield);
        }
        html = processTemplate("[[" + dfield + "]]", null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };
    self.Percent = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        var opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        if (opts.settings) {
            const r = getPercentModel(opts);
            const bdefault = r.vitems.length < 1 && !(r.color || r.bgcolor);
            if (bdefault) r.html = XPortal.Utils.RenderHtmlPercentBar("30%", r.percent);
            else {
                let citem = Object.assign({}, item, r);
                r.title = r.title ? processTemplate(r.title, '', citem, nodeId, dfield) : "";
                var pp = r.vitems.filter(v => v.maxVal >= r.percent);
                if (pp.length > 1) pp = pp.filter(v => (isNaN(Number(v.min)) ? 0 : v.min) <= r.percent);
                if (pp.length < 1) {
                    if (bdefault) r.html = XPortal.Utils.RenderHtmlPercentBar("30%", r.percent);
                    else r.html = processTemplate(r.defHtml, r.value, citem, nodeId, dfield);
                } else {
                    citem = Object.assign(citem, pp[0]);
                    r.html = processTemplate(pp[0].html, pp[0].value, citem, nodeId, dfield);
                }
            }
            return self.WrapCellExtended(r.html, item, nodeId, dfield);
        }
        let html = processTemplate("[[" + dfield + "]]", null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };
    self.TrimSeparators = function (str, separator, subst) {
        separator = separator || ",";
        subst = subst || separator + " ";
        if (!str || !str.length) return str;
        str = str.trim();
        const regex = /(\,\s+)+/gm;
        // const regex = new RegExp('(\\,\\s+)+', 'gm');
        const result = str.replace(regex, subst);
        return result;
    };
    self.Custom = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        const opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        if (opts && opts.settings && opts.settings.formula && opts.settings.formula.includes('(') && opts.settings.formula.includes(')')) {
            try {
                const funcContext = { item, dtype, dfield, inFormat, nodeId, htmlTemplate, value: item[dfield.toLowerCase()], opts, fOpts };
                return processFunction(funcContext);
            } catch (ex) { }
        }
        const tplt = opts.settings ? (opts.settings.formula || opts.settings.title) || "[[" + dfield + "]]" : "[[" + dfield + "]]";
        return processTemplate(tplt, item[dfield.toLowerCase()], item, nodeId, dfield);
    };
    self.FormattingRules = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        const opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        let html = "";
        if (opts.settings) {
            html = getFormattingRulesHtml(opts, item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts);
            return self.WrapCellExtended(html, item, nodeId, dfield);
        }
        html = processTemplate(`[[${dfield}]]`, null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };
    self.ProcessTemplate = function (inFormat, fvalue, doc, nodeId, dfield) {
        return processTemplate(inFormat, fvalue, doc, nodeId, dfield)
    };
    self.Tags = function (item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        var opts = getFieldSettings(dfield, inFormat, nodeId, item, fOpts);
        const tags = item[dfield.toLowerCase()] || [];
        let dTags = "";
        if (tags.length)
            dTags = item[dfield.toLowerCase()] = tags.split(',').join(self.valueSeparator);
        const grCode = XPortal.Template.ReplaceFormatString(opts.settings.groupcode, null, item, {});

        if (opts.settings) {
            let stts = opts.settings;
            stts.tags = dTags;
            stts.grCode = grCode;
            stts.uniqueId = item.UniqueId;
            stts.nodeId = opts.nodeId;
            stts.dField = dfield;
            stts.entityAlias = item.EntityAlias;
            const template = kendo.template($("#tagsGridFormat").html());
            return self.WrapCellExtended(template(stts), item, nodeId, dfield);
        }
        const html = processTemplate("[[" + dfield + "]]", null, item, nodeId, dfield);
        return XPortal.Grid.WrapCellContent(html);
    };

    self.WrapCellExtended = function (content, data, nodeId, field) {
        return "<span class=\"tdcell tdcell-extended\">" + content + "</span>";
    };

    function getFormattingRulesHtml(opts, item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts) {
        let classes = "";
        let style = "";
        let tooltip = "";
        let res = false;
        const formatRules = JSON.parse(JSON.stringify(opts.settings.items || []));
        let selector = "#entity-grid-" + opts.nodeId;
        let modelName = null;
        let $cont = $(selector);
        if ($cont.length) {
            modelName = XPortal.Store.getGridModelName($cont);
        }
        else {
            selector = "#detail-page-" + opts.nodeId;
            $cont = $(selector);
            modelName = $cont.length ? XPortal.Store.getModelName($cont) : null;
        }
        if (!modelName) return;
        const model = Object.assign({}, opts.item, { ModelName: modelName, NodeId: opts.nodeId });
        XPortal.SectionDisplayRules.updateRelatedModel(model.ModelName, formatRules, selector);
        formatRules.forEach(r => {
            let rulesResult = false;
            if (r.IsEnabled && r.Rules && r.Rules.length)
                rulesResult = XPortal.SectionDisplayRules.Processing.areRulesTrue(model, [...r.Rules], null, true, true);

            if (rulesResult) {
                classes = classes + " " + r.CssClasses;
                style = style + (style.length ? "; " : "") + r.StyleCss;
                const rTooltip = processTemplate(r.Tooltip, null, item, opts.nodeId, dfield);
                tooltip = tooltip + " " + rTooltip;
                res = true;
            }
        });
        tooltip = tooltip.trim();
        const htmlTooltip = tooltip && tooltip.length && res ? `<a href="javascript:void(0)" title="${tooltip}" class="tooltip fr-tooltip"><i class="icon-question"></i></a>` : "";
        let html = '';
        opts.settings.formula = opts.settings.title;
        const procTitle = self.Custom(item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts);
        if (!style.length && !classes.length && !htmlTooltip.length) {
            // in case formatting rule disabled or no rules applied return just tittle
            html = procTitle;
        } else {
            
            if (!procTitle.trim().length && !htmlTooltip.trim().length) {
                style = '';
                classes = '';
            }

            html = `<div class="${classes} conditional-formated-value" style="${style}">${procTitle} ${htmlTooltip}</div>`;
        }
        html = processTemplate(html, null, opts.item, opts.nodeId, opts.dfield);

        $("body").find(".has-ex-format-editable").each(function () {
            let label = $(this).parents('.form-group').find('>div:first-child');
            label.addClass('focused-hard');
        });

        return html;
    };
    function getFieldSettings(dfield, inFormat, nodeId, item, fOpts) {
        var res = {
            item, nodeId,
            dfield: dfield ? decodeURIComponent(dfield) : dfield,
            inFormat: inFormat ? decodeURIComponent(inFormat) : inFormat,
            settings: null
        };
        var dsFormat = fOpts ? fOpts : XPortal.Grid.ExtendedFormat(nodeId, dfield);
        res.settings = dsFormat && dsFormat.formatExtended ? dsFormat.formatExtended.Settings : null;
        return res;
    };
    function getAlertModel(opts) {
        var r = Object.assign({}, opts.settings);
        r.showCount = r.showCount || 2;
        r.showAllText = r.showMoreText || "Show more";
        r.showLessText = r.showLessText || "Show less";
        r.noAlertsMsg = r.noAlertsMsg || "No alerts to show";
        r.items.forEach(v => {
            const fcode = processTemplate(v.formula, null, opts.item, opts.nodeId, opts.dfield);
            try {
                v.data = v.value = contains(fcode, "=", ">", "<", "!", "+", "-", "*", "/", "") ? new Function('return ' + fcode)() : fcode;
            } catch (e) {
                v.data = v.value = fcode;
            }
            v.count = isNaN(Number(v.value)) ? 0 : Number(v.value);
            v.visible = v.value ? true : false;
            v.html = processTemplate(v.title, v.value, Object.assign({}, opts.item, v));
            if (v.link) v.html = getLinkHtml(opts, Object.assign({}, v.link, { title: v.html }));
        });
        r.vitems = r.items.filter(v => v.visible);
        r.count = 0;
        r.vitems.forEach((v, i) => {
            if (i >= r.showCount) v.css = "alert-show-less d-none";
            if (!isNaN(Number(v.value)) && v.value !== true && v.value !== false) r.count = r.count + Number(v.value);
            else r.count = r.count + (v.visible ? 1 : 0);
        });
        r.countwithparentheses = r.count ? `(${r.count})` : "";
        r.title = processTemplate(r.title, null, Object.assign({}, opts.item, r));
        r.css = r.count > 0 ? "" : "d-none";
        r.spanEmptyCss = r.vitems.length ? "d-none" : "";
        r.showAllBtnCss = r.showCount < r.vitems.length ? "" : "d-none";
        r.showLessBtnCss = "d-none";
        return r;
    };
    function getPercentModel(opts) {
        var r = Object.assign({}, opts.settings);
        r.vitems = _.sortBy(r.points || [], p => p.maxVal);
        pmax = null;
        r.defHtml = '<div style="background-color:' + r.bgcolor + ';color:' + r.color + ';width:calc([[percent]]% * 0.8);height:100%;text-align:center">[[title]]</div>';
        r.vitems.forEach(v => {
            v.min = pmax;
            v.bgcolor = v.bgcolor || (r.bgcolor || "MediumSeaGreen");
            v.color = v.color || r.color;
            v.html = '<div style="background-color:' + v.bgcolor + ';color:' + v.color + ';width:calc([[percent]]% * 0.8);height:100%;text-align:center">[[title]]</div>';
            v.maxVal = pmax = XPortal.Utils.parseNumber(v.maxVal);
            v.value = 0;
            v.title = v.title || r.title;
        });
        const fcode = processTemplate(r.formula, null, opts.item, opts.nodeId, opts.dfield);
        try {
            r.value = Number(contains(fcode, "+", "-", "*", "/", "") ? new Function('return ' + fcode)() : fcode);
        } catch (ex) {
            r.value = fcode;
        }
        r.value = r.data = isNaN(r.value) ? 0 : r.value;
        r.maxVal = XPortal.Utils.parseNumber(processTemplate(r.maxVal, 0, opts.item));
        r.percent = Math.round(r.maxVal > 0 ? 100 * (r.value / r.maxVal) : r.value);

        r.css = r.percent > 0 ? "" : "d-none";
        return r;
    };
    function getLinkHtml(opts, lnkStgs) {
        let lTitle = processTemplate(lnkStgs.title || opts.settings.title, null, opts.item, opts.nodeId, opts.dfield);
        const lUrl = processTemplate(lnkStgs.url || opts.settings.url, null, opts.item, opts.nodeId, opts.dfield);
        const lQuery = lnkStgs.query || opts.settings.query ? processTemplate(lnkStgs.query || opts.settings.query, null, opts.item, opts.nodeId, opts.dfield) : "";
        const lQueryStart = lQuery && lQuery.length && lQuery.substring(0, 1) != "?" ? "?" : "";
        const lTarget = opts.settings.target || lnkStgs.target ? opts.settings.target || lnkStgs.target : "_self";
        const res = $('<span><a href="' + lUrl + lQueryStart + lQuery + '">-</a></span>');
        const iLink = res.find("a");
        const readyHref = iLink.attr("href");
        if(readyHref.length == 0 && opts.settings.dialog == undefined) {
            lTitle = "";
        }
        iLink.html(lTitle);
        iLink.attr("target", lTarget);
        iLink.attr("data-dialog", JSON.stringify(opts.settings.dialog || {}));
        if (opts.settings.cssClass) iLink.addClass(opts.settings.cssClass);
        if (opts.settings.track) iLink.attr("data-activity", "link click");
        if (lTarget.toLowerCase() == "_popup") iLink.addClass("open-in-dialog");
        return res.html();
    }
    function contains(d, ...args) {
        return args.find(a => d.indexOf(a) > -1) ? true : false;
    };
    function processTemplate(inFormat, fvalue, doc, nodeId, dfield) {
        var res = inFormat;
        if (inFormat && (inFormat.indexOf("[[") >= 0 || inFormat.indexOf("##") >= 0))
            res = XPortal.Template.ReplaceFormatString(inFormat, fvalue, doc, nodeId, dfield);
        if (res && (res.indexOf("#=") >= 0 || res.indexOf("#:") >= 0))
            res = XPortal.Template.ApplyKendoTemplate(doc, res);
        return res;
    };
    function fSizeFormating(bytes, decimalPoint, sizesList) {
        const sizes = sizesList ? sizesList : ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        if (bytes == 0) return '0 ' + sizes[0];
        var k = 1000,
            dm = decimalPoint || 2,
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };

    //{"title":"Show file as image", "value":"XPortal.Format.ShowAsImage(value, item, dtype, dfield, fOpts,'', true, imageFieldName);", "description":"Show value as image taken from the specified field."}
    self.ShowAsImage = function (value, item, dtype, dfield, fOpts, style, noPreview, imageFieldName) {
        if (!value || value.length == 0)
            return value;
        var graphExts = ['gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg'];
        var isFileGraphic = graphExts.includes(item.fileextension);

        var noImageUrl = !isFileGraphic || noPreview ? "/content/images/icons/file_types/" + item.fileextension.replaceAll('.', '') + ".png" : "/content/images/empty-content-view-item.png";
        var fval = XPortal.Template.GetObjPropValueByName;
        if (isFileGraphic && (imageFieldName || (fOpts && fOpts.field)))
            var propVal = fval(item, imageFieldName ? imageFieldName : fOpts.field);
        var iurl = propVal == null || noPreview ? noImageUrl : encodeURIComponent(propVal);
        var ialias = fval(item, "alias");
        ialias = ialias ? ialias : fval(item, "entityalias");
        var purl = propVal == null || noPreview ? iurl : "/umbraco/Surface/Detail/ImageAltr?i=" + fval(item, "UniqueId") + "&a=" + ialias + "&src=&cnfr=1&file=" + iurl + "&f=Image&altr=" + noImageUrl;
        var r = $("<img/>");
        r.attr("src", purl);
        r.attr("alt", value);
        if (style && style.length > 0)
            r.attr("style", style)
        return $("<div/>").append(r).html();
    };
	//{"title":"Show as file download", "value":"XPortal.Format.linkToDownload(value, item, dfield, nodeId);", "description":"Render html link to download file"}
    self.linkToDownload = function (value, item, dfield, nodeId) {
        var customFormat = '<a class="download" href="/umbraco/Surface/Detail/DownloadAllAttachments?id=#=item.UniqueId#&KeyField=#=fname#&NodeId=[[nodeId]]&pinfo=#: details.parentInfo #" target="downloadFrm" title="#=title#">#=title#</a>';
        return XPortal.Template.base64(customFormat, value = Array.isArray(value) ? value : [value], item, dfield, nodeId);        
    };

    //{"title":"Convert file size to readable value", "value":"XPortal.Format.FormatFileSize(value,'Byte|KB|MB|GB|TB');", "description":"Convert value to value with a unit of measure."}
    self.FormatFileSize = function (val, sizesList) {
        if (!val || val == null) return '';
        sizesList = sizesList.split('|');
        if (!isNaN(val))
            return fSizeFormating(val, 2, sizesList);
        return val;
    };

    //{"title":"Replace value", "value":"XPortal.Format.ReplaceByExpression(value,'fromExpression','toExpression');", "description":"Replace value according to an expression."}
    self.ReplaceByExpression = function (value, from, to) {
        if (!value || value.length == 0 || !from || !to)
            return value;
        return value.toString().replaceAll(from, to);
    };
    //{"title":"Replace value depends of expression", "value":"XPortal.Format.ReplaceByExpressionBoth(value,'fromExpression','toExpression','falseexpresion');", "description":"Replace value according to an expression."}
    self.ReplaceByExpressionBoth = function (value, from, to, falsefrom) {
        if (!value || value.length == 0 || !from || !to) {
            if (falsefrom) return falsefrom;
            return value;
        }
        return value.toString().replaceAll(from, to);
    };

    //{"title":"Look up value", "value":"XPortal.Format.ConditionDisplay(value, item, 'value condition');", "description":"Look up value from a static list specified in the expression."}
    self.ConditionDisplay = function (value, item, condition) {
        if (!value || value.length == 0 || !item || !condition || condition.length == 0)
            return value;

        var conditionList = condition.split('|');
        if (conditionList.length == 0)
            return value;

        var condList = {};
        conditionList.forEach(function (c) {
            var cTmp = c.split(':');
            if (cTmp.length < 2)
                return;
            condList[cTmp[0]] = cTmp[1];
        });

        if (condList[value]) {
            var propVal = XPortal.Template.GetObjPropValueByName(item, condList[value]);
        }
        return propVal ? propVal : value;
    };
    //{"title":"Trim concatenated field value", "value":"XPortal.Format.TrimSeparators(context,'[[field1]], [[field2]], [[field3]]',   ',');", "description":"Remove empty values, including the nearby separator (the comma (,) by default), from a concatenated value (a combination of multiple field values). If you need to remove another separator, specify it as a 3rd parameter (for example: , \";\" or , \"-\").","toreplace":"'[[field1]], [[field2]], [[field3]]'"}
    self.TrimSeparators = function (context, str, separator) {
        separator = (separator || ',').trim();
        const item = context.item;
        if (!str || !str.length) return str;
        str = str.trim();
        const r = '\\[\\[([^\\]]*)]]\\s*\\' + separator + '*\\s*';
        if (new RegExp(r, "gm").exec(str) == null) {
            if (context.opts) context.opts.isRawRequeired = true;
            return str;
        }
        let suffix = "";
        const result =
            getTrimPrefix(str, r, item, s => str = s) +
            getTrimItems(str, r, item, s => suffix = s, separator + " ") +
            suffix;
        return result;
    };
    function getTrimPrefix(strToProcess, regex, item, onTrim) {
        ritems = new RegExp(regex, "gm").exec(strToProcess);
        if (!ritems || !ritems.length) return "";
        onTrim(strToProcess.substr(ritems.index));
        return strToProcess.substr(0, ritems.index);
    };
    function getTrimItems(strToProcess, regex, item, onSuffix, separator) {
        const res = [];
        let pstr = strToProcess;
        do {
            ritems = new RegExp(regex, "gm").exec(pstr);
            if (ritems && ritems.length) {
                const suffix = processTemplate("[[" + ritems[1] + "]]", null, item);
                const prefix = pstr.substr(0, ritems.index);
                if (!XPortal.Utils.htmlIsEmpty(suffix)) {
                    res.push(prefix + suffix);
                }
                pstr = pstr.substr(ritems.index + ritems[0].length);
            }
        } while (ritems && ritems.length);
        onSuffix(pstr || "");
        return res.join(separator);
    };

    function processFunction(context) {
        const opts = context.opts;
        opts.isRawRequeired = false;
        const funcString = processTemplate(opts.settings.formula, null, context.item, context.nodeId, context.dfield);

        let func = new Function('context', 'with(context){\r\n     return ' + funcString + '; \r\n    }');

        let fres = func.call(context, context);
        if (!opts.isRawRequeired) return fres;
        //possibility to send template as part of function query and process template directly in it
        func = new Function('context', 'with(context){\r\n     return ' + opts.settings.formula + '; \r\n    }');

        return func.call(context, context);
    };
    return self;
}());


//{"title":"Configure how empty value is displayed", "value":"XPortal.Format.ReplaceByExpressionBoth(value,value,value,'No data');", "description":"Set up how the empty value is displayed. By default, the empty value with this expression is displayed as 'No data', which can be changed to the one that you want to be displayed. For example: 'Empty', 'Null' or '-'"}

//{"title":"Configure how boolean value is displayed", "value":"XPortal.Format.ReplaceByExpressionBoth(value,/true|1/g,'Yes','No');", "description":"Set up how the boolean value is displayed. Replace the default values ('true' or 'false') to the ones that you want to be displayed. For example: 'Yes' or 'No', 'On' or 'Off'."}
